import React from "react";
import ReactDom from "react-dom";
import App from "./App";
import './style.css'

function MyApp() {
  return (
    <>
      <div className="preloader">
        <div></div>
      </div>
      <App />
    </>
  );
}

ReactDom.render(<MyApp />, document.getElementById("root"));
